module.exports = __webpack_public_path__ + "media/images/service/b_2-dce259c7c90360543d6a95802a2fd575.png";